import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_Popup = _resolveComponent("Popup")
  const _component_Loading = _resolveComponent("Loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    _createVNode(_TransitionGroup, { name: "page" }, {
      default: _withCtx(() => [
        (_ctx.isDisplay)
          ? (_openBlock(), _createBlock(_component_Popup, {
              key: "popup",
              onClose: _ctx.closePopup,
              type: _ctx.popupTypeName
            }, {
              title: _withCtx(() => [
                _createVNode("div", { innerHTML: _ctx.title }, null, 8, ["innerHTML"])
              ]),
              description: _withCtx(() => [
                _createVNode("div", { innerHTML: _ctx.description }, null, 8, ["innerHTML"])
              ]),
              _: 1
            }, 8, ["onClose", "type"]))
          : _createCommentVNode("", true),
        (_ctx.loadingCounter > 0)
          ? (_openBlock(), _createBlock(_component_Loading, { key: "loading" }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}